module.exports = __webpack_public_path__ + "media/images/products/products/f4-2821e308050db5934a573a319a308761.jpg";